export const PHOTO_NAME_DATE_FORMAT = "YYYY_MM_DD";
